<template>
  <div class="w-full flex">

    <!-- Preview for form editor -->
    <div v-if="productData == null" class="w-full flex gap-1 items-center">
      <input @change="(e) => { e.preventDefault(); e.target.checked = true;}" :checked="true" type="checkbox" class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 my-1" >
    </div>

    <!-- Fieldtype -->
    <div v-else class="w-full flex gap-1 items-center">
      <!-- <input type="checkbox" class="outline-0 border border-bg-trader-input-border border-header p-1 my-1 w-4 h-4" v-model="active" @change="toggle"> -->
      <input type="checkbox"
             class="p-1 w-4 h-4 my-1 "
             :disabled="readOnly"
             :checked="localGetFieldValue(formField.field, 'boolean')"
             @change="(event) => onChangeProductFieldValue(formField.field, 'boolean', event.target.checked)"
             :class="{ 'bg-inactive' : formField.readOnly, 'shadow-trader-red': productData.customFields[formField.field]?.highlight }"
             :data-ui="'checkbox-'+ formField.label">
    </div>

  </div>
</template>

<script>
export default {
  props: {
    name: "Article Number Checkbox",
    formField: {
      type: Object,
      default: () => {
      }
    },
    productData: {
      type: Object,
      default: () => {
      }
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {}
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    localGetFieldValue(fieldName, type) {
      if (type === 'boolean') {
        const boolean = this.productData.customFields[fieldName]?.value !== 'no';
        return boolean;
      }
      return this.productData.customFields[fieldName]?.value;
    }
  }
}
</script>


